import infoModal from '../InfoModal'
import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react'
import './UserProfile.css'
import Avatar from '../Avatar/Avatar'
import Icon from '../Icon2'
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch'
import { Truncate } from '../Truncate/Truncate'

import Line from '../Line/Line';
import Dropdown from '../DropDown/Dropdown';

type UserProfileProps = {
  orgName: string
  list: ListType
  type: AvatarType
  avatar: AvatarData
  handleEvent: (e: any) => void
  testId?: string
  closeModal?: (e: any) => void
  orgBannerImageUrl?: string | undefined
  onImageSelect?: (e: any) => void
  isOwner?: boolean,
  appendOrgBannerCover?: any
}

type ListItem = {
  icon?: string
  text?: string
  toggle?: ToggleData
  iconVersion?: string
  id: string,
  dropdown?: boolean,
  orgData?: OrgData[],
}

type OrgData = {
  label: React.JSX.Element,
  value: string,
  action: () => void
};

type ListType = ListItem[]

type AvatarType = 'text' | 'image'

type AvatarData = {
  image?: string
  name: string
  email: string
}

type ToggleData = {
  checked: boolean
}

function displayAvatarContent(type, avatar) {
  if (type === 'image') {
    return <img src={avatar.image} alt={avatar.name} className="Avatar__imagee" />
  }
  let nameInitials = avatar && avatar.name && avatar.name.split(' ')
  let firstInitial = (nameInitials && nameInitials[0]) || ''
  let lastInitial = (nameInitials && nameInitials[nameInitials?.length - 1]) || ''
  let nameInitialsShort =
    nameInitials && nameInitials.length === 1
      ? nameInitials[0]
      : firstInitial?.substring(0, 1) + lastInitial?.substring(0, 1)
  return nameInitialsShort
}

const UserAvatar = ({ type, avatar }) => {
  return (
    <div className="Avatar--pic">
      <span className="Avatar__link">{displayAvatarContent(type, avatar)}</span>
    </div>
  )
}

const Options = ({ list, handleEvent, closeModal, orgName }) => {
  return (
    <div className="options">
      {list.map((item, key) => {
        if (item?.dropdown) {
          return <div className='organization_body'>
            <Line type='solid' width={284} />
            <div className='switch_organization'>
              <p>Switch organization</p>
            </div>
            <Dropdown
              type='click'
              list={item.orgData || []}
              version='v2'
              closeAfterSelect={true}
              withIcon={true}
              onChange={(e) => {
                closeModal();
              }}
            >
              <div className='organization_label' data-test-id="cs-userprofile-orgdropdown">
                {orgName}
                <Icon icon='CaretRight' size='medium' version='v2' />
              </div>
            </Dropdown>
            <Line type='solid' width={284} />
          </div>
        } else {
          return <label
            key={key}
            onClick={
              (e) => {
                handleEvent(e)
                if (!item?.toggle) {
                  closeModal()
                }
              }}
            className={`list-option ${item?.toggle ? 'switch-option' : ''}`}
            id={!item?.toggle ? item?.id || "" : ""}
            data-test-id='cs-userprofile-click'
          >
            <Icon icon={item.icon} version={item.iconVersion || 'v2'} size="medium" />
            {item?.text}
            {item?.toggle && <ToggleSwitch id={item.id} defaultChecked={item.toggle?.checked} testId={item.toggle.testId} />}
          </label>
        }
      })
      }
    </div >
  )
}

const MyComponent = ({ orgName, list, type, avatar, handleEvent, closeModal, orgBannerCover, onImageSelect, isOwner }: any) => {

  //   const [orgBannerCover, setOrgBannerCover] = useState(orgBannerImageUrl)
  // useEffect(() => {
  //   console.log('orgBannerImageUrl called in useEff ==> ', orgBannerImageUrl)
  //   setOrgBannerCover(orgBannerImageUrl)
  // }, [orgBannerImageUrl])

  console.log('orgBannerImageUrl called ==> ', orgBannerCover)
  const appendOrgBannerCover = orgBannerCover ? {
    backgroundImage: `url(${orgBannerCover})`,
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  } : {}
  const fileRef = useRef(null);

  const simulateUpload = () => {
    console.log('upload', fileRef)
    fileRef.current.click();
  }

  return (
    <div className="UserProfile">
      <div className="org" style={appendOrgBannerCover}>
        {isOwner && <div className='hover-overlay'>
          <Icon
            id="editOrgBanner"
            onClick={
              simulateUpload
            }
            className="editOrgBanner"
            icon={'Edit'}
            version="v2"
            size="small"
          />
          <p
            onClick={simulateUpload}
            data-test-id='cs-userprofile-simulateupload'
          >Edit Organisation Image</p>
          <input
            type="file"
            id="replace-file-input"
            name="asset"
            onChange={(e) => onImageSelect(e)}
            ref={fileRef}
            multiple={false}
            accept="image/*"
            style={{ display: 'none' }}
            data-test-id="cs-userprofile-replacefileinput"
          />
        </div>}

      </div>
      <div className="user-info">
        <UserAvatar type={type} avatar={avatar} />
        <div className="email">
          <Truncate maxChar={30}>{avatar.email}</Truncate>
        </div>
        <div className="name">
          <Truncate>{avatar.name}</Truncate>
        </div>
      </div>
      <Options list={list} handleEvent={handleEvent} closeModal={closeModal} orgName={orgName} />
    </div>
  )
}

const UserProfile = forwardRef(({ orgName, list, type, avatar, handleEvent, testId = 'user-profile', orgBannerImageUrl, onImageSelect, isOwner }: UserProfileProps, ref) => {
  const targetRef = useRef(null)
  const portalRef = useRef(null)
  let [isModalOpen, setIsModalOpen] = useState(false)

  const [orgBannerCover, setOrgBannerCover] = useState(orgBannerImageUrl)
  useEffect(() => {
    console.log('orgBannerImageUrl called in useEff ==> ', orgBannerImageUrl)
    setOrgBannerCover(orgBannerImageUrl)
    onClose()
  }, [orgBannerImageUrl])

  const onClose = () => {
    setIsModalOpen(false)
  }
  const reopenModal = () => {
    console.log("Re Open Modal");
    targetRef?.current.click()
  }

  useImperativeHandle(ref, () => ({
    callInternalMethod: () => reopenModal()
  }));

  const handleClick = () => {
    if (!isModalOpen) {
      setIsModalOpen(true)
      infoModal({
        component: (props) => (
          <MyComponent {...{ orgName, list, type, avatar, handleEvent, closeModal: props.closeModal, orgBannerCover, onImageSelect, isOwner }} />
        ),
        modalProps: {
          onClose,
          targetNodeOrId: targetRef.current,
          closeOnOverlayClick: true,
          ignoreContainers: ['parentid'],
          portal: {
            sourceElem: portalRef.current,
            AdjustLeftOffset: -270,
            AdjustTopOffset: 18
          }
        }
      })
    }
  }

  return (
    <div ref={targetRef} data-test-id={testId}>
      <label ref={portalRef} onClick={handleClick}>
        <Avatar
          type={type}
          avatars={[{ name: avatar.name, email: avatar.email, id: 1, image: avatar.image, avatarColor: '' }]}
        />
      </label>
    </div>
  )
});
UserProfile.displayName = 'UserProfile';
export default UserProfile